import React from 'react';
import EventCalendar from '../EventCalendar';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import {BreadcrumbItem, Breadcrumb} from 'react-bootstrap';
import { Link } from 'react-router-dom';
function TodayEvents() {
  return (
    
    <div className='TodayEvents'>
      <EventCalendar/>
    </div>
  );

}

export default TodayEvents;